import { useEffect, useState } from 'react';
import { useContent } from '../hooks/useContent';
import ProgramIcon from '../components/ProgramIcon';
import './PNF.css';

const ALGO_BLOCKS = [
  {
    id: 'preschool',
    icon: 'preschool',
    tag: 'Дошкольное образование',
    title: 'Алгоритм расчета подушевого нормативного финансирования дошкольного воспитания и обучения регламентирован приказом Министра образования и науки Республики Казахстан от 27 ноября 2017 года № 597 «Об утверждении Методики подушевого нормативного финансирования дошкольного воспитания и обучения, среднего образования, а также технического и профессионального, послесреднего образования с учетом кредитной технологии обучения».',
    norm: 'Приказ МОН РК от 27 ноября 2017 года № 597',
    normUrl: 'https://adilet.zan.kz/rus/docs/V2000021489',
    desc: 'Расчёты выполняются в зависимости от группы назначения и режима пребывания воспитанника.',
    items: [
      { label: 'Группы общего назначения и коррекционного типа', text: 'Включают группы для детей с туберкулёзными, аллергическими заболеваниями, сахарным диабетом, ослабленных и часто болеющих детей.' },
      { label: 'Режимы пребывания', text: 'Неполный день / предшкольная подготовка при школе; 9-часовой режим; 10,5-часовой режим.' },
      { label: 'Доплаты специалистам', text: 'За работу в сельской местности, за замещение сотрудников, за проживание в зоне экологического бедствия и в зоне радиационного риска.' },
    ],
    note: 'Объём ПНФ определяется не ниже норматива, рассчитанного в соответствии с Методикой.',
  },
  {
    id: 'school',
    icon: 'school',
    tag: 'Среднее образование',
    title: 'Алгоритм расчета подушевого нормативного финансирования среднего образования регламентирован приказом Министра образования и науки Республики Казахстан от 27 ноября 2017 года № 597 «Об утверждении Методики подушевого нормативного финансирования дошкольного воспитания и обучения, среднего образования, а также технического и профессионального, послесреднего образования с учетом кредитной технологии обучения».',
    norm: 'Приказ МОН РК от 27 ноября 2017 года № 597',
    normUrl: 'https://adilet.zan.kz/rus/docs/V2000021489',
    desc: 'Расчёты выполняются в зависимости от класса обучения и времени пребывания обучающегося.',
    items: [
      { label: '1-4 классы', text: 'Общеобразовательные классы, в т.ч. ООП (инклюзив), специальные (коррекционные) классы, обучение на дому с учётом деления на подгруппы.' },
      { label: '5-9 классы', text: 'Все действующие школы вне зависимости от формы собственности, включая интернаты при частных организациях.' },
      { label: '10-11 классы', text: 'Обучающиеся в частных школах-интернатах и государственных организациях среднего образования.' },
      { label: 'Доплаты специалистам', text: 'За работу в сельской местности, за квалификационный уровень педагогов, за проживание в зоне экологического бедствия и радиационного риска.' },
    ],
    note: null,
  },
  {
    id: 'tippo',
    icon: 'tippo',
    tag: 'ТиПО / Послесреднее',
    title: 'Алгоритм расчета подушевого нормативного финансирования технического и профессионального, послесреднего образования регламентирован приказом Министра образования и науки Республики Казахстан от 27 ноября 2017 года № 597 «Об утверждении Методики подушевого нормативного финансирования дошкольного воспитания и обучения, среднего образования, а также технического и профессионального, послесреднего образования с учетом кредитной технологии обучения».',
    norm: 'Приказ МОН РК от 27 ноября 2017 года № 597',
    normUrl: 'https://adilet.zan.kz/rus/docs/V2000021489',
    desc: 'Расчёты выполняются в зависимости от специальности - группы А, Б, В или Г.',
    items: [
      { label: 'Группа А', text: 'Педагогические специальности (воспитатели, преподаватели), отдельные направления искусства и гуманитарных наук (каллиграфия, теология), библиотечное дело, право, метрология.' },
      { label: 'Группа Б', text: 'Профессиональное обучение, ИКТ, языкознание, бизнес и управление (кроме права), естественные науки, ряд инженерных направлений (слесарное дело, электроника, медтехника, сельское хозяйство), социальная работа.' },
      { label: 'Группа В', text: 'Дизайн, ювелирное дело, реставрация, музыка и театр, народное творчество, большинство инженерных и строительных специальностей, общепит.' },
      { label: 'Группа Г', text: 'Эксплуатация водного транспорта, электрорадиомонтаж морской техники.' },
    ],
    note: 'Объём ПНФ определяется не ниже норматива, рассчитанного в соответствии с Методикой.',
  },
  {
    id: 'ovpo',
    icon: 'ovpo',
    tag: 'Высшее / Послевузовское образование',
    title: 'Алгоритм расчета подушевого нормативного финансирования технического и профессионального, послесреднего образования регламентирован приказом Министра науки и высшего образования Республики Казахстан от 10 июля 2023 года № 311 «О некоторых вопросах подушевого нормативного финансирования высшего и (или) послевузовского образования с учетом кредитной технологии обучения.',
    norm: 'Приказ МНВО РК от 10 июля 2023 года № 311',
    normUrl: 'https://adilet.zan.kz/rus/docs/V1700016137',
    desc: 'ПНФ высшего и послевузовского образования реализуется за счёт республиканского и (или) местного бюджетов с учётом кредитной технологии обучения.',
    items: [
      { label: 'Плановый объём', text: 'Организация определяет плановый объём ПНФ по контингенту учащихся и планируемым кредитам по образовательным программам и представляет оператору не позднее 10 календарных дней с начала академического периода.' },
      { label: 'Ежеквартальная сверка', text: 'Организация ведёт ежеквартальную сверку контингента обучающихся и фактически предоставленных кредитов в разрезе образовательных программ.' },
      { label: 'Ежеквартальная отчётность', text: 'Не позднее 20-го числа месяца, предшествующего кварталу, представляется информация о фактическом контингенте по состоянию на 15-е число (за январь и сентябрь - на 30-е число) с учётом нового приёма.' },
    ],
    note: null,
  },
];

export default function PNF() {
  const { PNF_PROGRAMS, ui } = useContent();
  const pnfUi = ui.pnf;
  const summaryMeta = pnfUi.summaryMeta || [];
  const summaryRows = summaryMeta.map((row, i) => ({
    icon: ['preschool', 'school', 'tippo', 'ovpo', 'palette', 'savings'][i],
    ...row,
    label: pnfUi.summaryRows[i],
  }));
  const [active, setActive] = useState(0);
  const [iframeUrl, setIframeUrl] = useState(null);
  const prog = PNF_PROGRAMS[active];

  useEffect(() => {
    const hashToProgramId = {
      '#pnf-preschool': 'preschool',
      '#pnf-school': 'school',
      '#pnf-tippo': 'tippo',
      '#pnf-ovpo': 'ovpo',
      '#pnf-extra': 'extra',
      '#pnf-gons': 'gons',
      '#pnf-dorms': 'dorms',
    };

    const applyTabByHash = () => {
      const targetProgramId = hashToProgramId[window.location.hash];
      if (!targetProgramId) return;

      const targetIndex = PNF_PROGRAMS.findIndex((p) => p.id === targetProgramId);
      if (targetIndex !== -1) {
        setActive(targetIndex);
        setIframeUrl(null);
      }
    };

    applyTabByHash();
    window.addEventListener('hashchange', applyTabByHash);
    return () => window.removeEventListener('hashchange', applyTabByHash);
  }, []);

  return (
    <section id="pnf" style={{ background: 'var(--offwhite)' }}>
      <div className="section">
        <div className="section-label">{pnfUi.label}</div>
        <h2 className="section-title">
          {pnfUi.title}
          <br />
          <em>{pnfUi.titleEm}</em>
        </h2>
        <p className="section-subtitle" style={{ maxWidth: 680 }}>{pnfUi.subtitle}</p>

        {/* PROGRAM TABS */}
        <div className="pnf-tabs">
          {PNF_PROGRAMS.map((p, i) => (
            <button
              key={i}
              id={`pnf-${p.id}`}
              className={`pnf-tab ${i === active ? 'active' : ''}`}
              onClick={() => { setActive(i); setIframeUrl(null); }}
            >
              <span className="pnf-tab-icon">
                <ProgramIcon name={p.icon} size={18} />
              </span>
              <span className="pnf-tab-label">{p.tag}</span>
            </button>
          ))}
        </div>

        {/* ACTIVE PROGRAM CARD */}
        <div className="pnf-card">
          <div className="pnf-card-header">
            <div>
              <div className="pnf-card-tag">{prog.tag}</div>
              <h3 className="pnf-card-title">{prog.title}</h3>
              <p className="pnf-card-subtitle">{prog.subtitle}</p>
            </div>
            <div className="pnf-card-icon">
              <ProgramIcon name={prog.icon} size={48} />
            </div>
          </div>

          <div className="pnf-stats">
            {prog.stats.map((s, i) => (
              <div key={i} className="pnf-stat">
                <strong>{s.v}</strong>
                <span>{s.l}</span>
              </div>
            ))}
          </div>

          <p className="pnf-desc">{prog.desc}</p>
          {prog.id === 'gons' && <KeleshekSection />}

          {/* ORTA-BILIM PORTALS */}
          {prog.portals.length > 0 && (
            <div className="pnf-portals">
              <div className="pnf-portals-label">
                <span className="pnf-portals-label-icon">
                  <ProgramIcon name="chart" size={16} />
                </span>
                {pnfUi.portalsStats}
              </div>
              <div className="pnf-portal-btns">
                {prog.portals.map((portal, i) => (
                  <button
                    key={i}
                    className={`pnf-portal-btn ${iframeUrl === portal.url ? 'active' : ''}`}
                    onClick={() => setIframeUrl(iframeUrl === portal.url ? null : portal.url)}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/></svg>
                    {portal.label}
                  </button>
                ))}
                
              </div>

              {iframeUrl && (
                <div className="pnf-iframe-wrap">
                  <div className="pnf-iframe-header">
                    <span>{prog.portals.find(p => p.url === iframeUrl)?.label}</span>
                    <button className="pnf-iframe-close" onClick={() => setIframeUrl(null)}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </button>
                  </div>
                  <iframe
                    src={iframeUrl}
                    title="Статистика орта-билим"
                    className="pnf-iframe"
                    loading="lazy"
                    sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* SUMMARY TABLE */}
        <div className="pnf-summary">
          <h3 className="pnf-summary-title">{pnfUi.summaryTitle}</h3>
          <div className="pnf-table-wrap">
            <table className="pnf-table">
              <thead>
                <tr>
                  {pnfUi.tableHead.map((h) => (
                    <th key={h}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {summaryRows.map((row) => (
                  <tr key={row.label}>
                    <td>
                      <span className="pnf-table-label">
                        <ProgramIcon name={row.icon} size={16} />
                        {row.label}
                      </span>
                    </td>
                    <td>{row.orgs}</td>
                    <td>{row.contingent}</td>
                    <td>{row.budget}</td>
                  </tr>
                ))}
                <tr className="pnf-table-total"><td><strong>{pnfUi.totalRow}</strong></td><td><strong>~25 тыс.</strong></td><td><strong>~7,5 млн чел.</strong></td><td><strong>~5,87 трлн тг</strong></td></tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* ALGO BLOCKS */}
        <div className="pnf-algo-section">
          <h3 className="pnf-summary-title">{pnfUi.algoTitle}</h3>
          <div className="pnf-algo-grid">
            {ALGO_BLOCKS.map((block) => (
              <AlgoCard key={block.id} block={block} />
            ))}
          </div>
        </div>
        
      </div>
    </section>
  );
}

function AlgoCard({ block }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`pnf-algo-card ${open ? 'pnf-algo-card--open' : ''}`}>
      <button className="pnf-algo-card__header" onClick={() => setOpen(o => !o)}>
        <div className="pnf-algo-card__left">
          <span className="pnf-algo-card__icon">
            <ProgramIcon name={block.icon} size={28} />
          </span>
          <div>
            <div className="pnf-algo-card__tag">{block.tag}</div>
            <div className="pnf-algo-card__title">{block.title}</div>
          </div>
        </div>
        <svg className="pnf-algo-card__chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {open && (
        <div className="pnf-algo-card__body">
          <div className="pnf-algo-card__norm">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            {block.normUrl
              ? <a href={block.normUrl} target="_blank" rel="noreferrer" className="pnf-algo-card__norm-link">{block.norm}</a>
              : block.norm}
          </div>
          <p className="pnf-algo-card__desc">{block.desc}</p>
          <div className="pnf-algo-card__items">
            {block.items.map((item, i) => (
              <div key={i} className="pnf-algo-item">
                <div className="pnf-algo-item__label">{item.label}</div>
                <div className="pnf-algo-item__text">{item.text}</div>
              </div>
            ))}
          </div>
          {block.note && (
            <div className="pnf-algo-card__note">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              {block.note}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
const MRP_2025 = 3932; // МРП 2025 года

function KeleshekSection() {
  const { ui } = useContent();
  const pnfUi = ui.pnf;
  const [startCapital, setStartCapital] = useState(60);   // МРП: 60 или 120
  const [premiumPct, setPremiumPct] = useState(6);
  const [bankPct, setBankPct] = useState(12.4);
  const [parentMRP, setParentMRP] = useState(48);
  const [years, setYears] = useState();
  const [result, setResult] = useState(null);

  const calculate = () => {
  const start = startCapital * MRP_2025;
  const parentYear = parentMRP * MRP_2025;
  const r = bankPct / 100;
  const rp = premiumPct / 100;

  let balance = start;
  let totalParent = 0;
  let totalPremium = 0;
  let totalBank = 0;

  for (let y = 0; y < years; y++) {
  const premium = parentYear * rp;
  const base = balance + parentYear + premium;
  const bankIncome = Math.floor(base * r);
  balance = base + bankIncome;

  totalParent += parentYear;
  totalPremium += premium;
  totalBank += bankIncome;
}

setResult({ total: Math.round(balance), start, totalParent: Math.round(totalParent), totalPremium: Math.round(totalPremium), totalBank: Math.round(totalBank) });
};

  const fmt = (n) => Math.round(n).toLocaleString('ru-KZ') + ' ₸';

  return (
    <div className="keleshek">
      <div className="keleshek-header">
        <div className="keleshek-tag">{pnfUi.keleshekTag}</div>
        <h3 className="keleshek-title">{pnfUi.keleshekTitle}</h3>
        <p className="keleshek-desc">{pnfUi.keleshekDesc}</p>
      </div>

      <div className="keleshek-features">
        {pnfUi.keleshekFeatures.map((text, i) => {
          const icons = ['gift', 'trending-up', 'shield', 'scale', 'ovpo', 'calendar'];
          return { icon: icons[i], text };
        }).map((f, i) => (
          <div key={i} className="keleshek-feature">
            <span className="keleshek-feature-icon">
              <ProgramIcon name={f.icon} size={22} />
            </span>
            <span className="keleshek-feature-text">{f.text}</span>
          </div>
        ))}
      </div>

      <div className="keleshek-calc">
        <div className="keleshek-calc-title">
          <span className="keleshek-calc-title-icon">
            <ProgramIcon name="calculator" size={22} />
          </span>
          {pnfUi.calcTitle}
        </div>

        <div className="keleshek-fields">
          <div className="keleshek-field">
            <label>Стартовый капитал от государства</label>
            <div className="keleshek-radio-group">
              {[60, 120].map(v => (
                <button key={v} className={`keleshek-radio ${startCapital === v ? 'active' : ''}`} onClick={() => setStartCapital(v)}>
                  {v} МРП ({fmt(v * MRP_2025)})
                </button>
              ))}
            </div>
          </div>

          <div className="keleshek-field">
            <label>Ежегодный взнос родителями</label>
            <div className="keleshek-input-row">
              <input className="keleshek-input" type="number" value={parentMRP} onChange={e => setParentMRP(+e.target.value)} min={0} />
              <span className="keleshek-input-unit">МРП / год ({fmt(parentMRP * MRP_2025)})</span>
            </div>
          </div>

          <div className="keleshek-field">
            <label>Ежегодная государственная премия</label>
            <div className="keleshek-input-row">
              <input className="keleshek-input" type="number" value={premiumPct} onChange={e => setPremiumPct(+e.target.value)} min={0} max={100} step={0.1} />
              <span className="keleshek-input-unit">%</span>
            </div>
          </div>

          <div className="keleshek-field">
            <label>Ежегодное вознаграждение банка</label>
            <div className="keleshek-input-row">
              <input className="keleshek-input" type="number" value={bankPct} onChange={e => setBankPct(+e.target.value)} min={0} max={100} step={0.1} />
              <span className="keleshek-input-unit">%</span>
            </div>
          </div>

          <div className="keleshek-field" style={{ gridColumn: '1 / -1' }}>
            <label>Срок депозита</label>
            <div className="keleshek-input-row">
              <input className="keleshek-input" type="number" value={years} onChange={e => setYears(+e.target.value)} min={1} max={25} />
              <span className="keleshek-input-unit">лет</span>
            </div>
          </div>
        </div>

        <button className="keleshek-calc-btn" onClick={calculate}>Вычислить</button>

        {result && (
          <div className="keleshek-result">
            <div className="keleshek-result-label">Итого сумма накопления</div>
            <div className="keleshek-result-amount">{fmt(result.total)}</div>
            <div className="keleshek-result-breakdown">
              <div className="keleshek-result-item">
                <strong>{fmt(result.start)}</strong>
                <span>Стартовый капитал от государства</span>
              </div>
              <div className="keleshek-result-item">
                <strong>{fmt(result.totalParent)}</strong>
                <span>Взносы родителей за {years} лет</span>
              </div>
              <div className="keleshek-result-item">
                <strong>{fmt(result.totalPremium)}</strong>
                <span>Государственные премии</span>
              </div>
              <div className="keleshek-result-item">
                <strong>{fmt(result.totalBank)}</strong>
                <span>Банковское вознаграждение</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}